

























import {defineComponent, ref} from "@vue/composition-api";
import AuthLayout from '@tool/Layouts/AuthLayout.vue';
import useFormHelper from "@tool/Helpers/useFormHelper";
import FormError from "@tool/Components/FormError.vue";
import useAxios from "@tool/Helpers/useAxios";

export default defineComponent({
    components: {
        AuthLayout,
        FormError,
    },

    setup(props) {
        const form = useFormHelper({
            email: ''
        });

        const message = ref<string | null>(null);

        const formHandle = async () => {
            const response = await form.value.submit(async (data) => {
                return useAxios().post<{ message: string; }>(route('auth.password.forgot.post'), {
                    email: data.email,
                });
            });

            if (response.success) {
                message.value = response.success.message;
            }
        }

        return {
            form,
            formHandle,
            message
        }
    },

})
